import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/providers/auth-provider';

export function LoginPage() {
  const { signIn, status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') {
      navigate({ to: '/' });
    }
  }, [status, navigate]);

  const handleGoogleSignIn = () => {
    signIn();
  };

  return (
    <div className="flex min-h-[calc(100vh-7rem)] items-start justify-center bg-background p-4 pt-[14vh]">
      <Card className="w-full max-w-md">
        <CardHeader className="relative text-center">
          <span className="comic-burst absolute -top-3 -right-2 rotate-12 px-4 py-2 font-display text-lg">POW!</span>
          <CardTitle className="font-display text-5xl tracking-wide text-primary [-webkit-text-stroke:1.5px_var(--color-border)]">
            Brain of Chris
          </CardTitle>
          <CardDescription className="text-base">
            Calling all heroes! Assemble for a mission to see Chris — sign in to claim a mission slot.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={handleGoogleSignIn} className="w-full" size="lg" disabled={status === 'loading'}>
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" role="img" aria-label="Google">
              <title>Google</title>
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Sign in with Google
          </Button>

          <div className="text-center text-sm text-muted-foreground">Authorized heroes only</div>
        </CardContent>
      </Card>
    </div>
  );
}
